import React from 'react';
import PropTypes from 'prop-types';
import ChevronUpIcon from 'zignal-landscape/lib/Icon/ChevronUpIcon';
import DropdownIcon from 'zignal-landscape/lib/Icon/DropdownIcon';
import Loading from 'zignal-landscape/lib/Loading';
import Label from 'zignal-landscape/lib/Label';
import Link from 'zignal-landscape/lib/Link';
import SourceCheckerResult from '../../../SourceCheckerResult';

const SourceCheckerMediaOutletList = (props) => {
  const {
    styles,
    selectedSourceType,
    results,
    filters,
    filterHandler,
    onShowSimilarSources,
    onHideSimilarSources,
    similarSources,
    showSourceCheckerSimilars,
    fetchingSimilarFor,
    hasGroups,
  } = props;

  // Processing exact matches
  const resultComponentsMap = results.reduce((components, sourceCheckerResult, i) => {
    const {
      domain,
      authorGroupNames,
      isCovered,
      isValid,
      lastCoveredAt,
      mediaOutlet,
      sourceProviders,
      storyCount,
    } = sourceCheckerResult;

    const showResult = filterHandler(filters, sourceCheckerResult);

    if(showResult) {
      if(!components.has(mediaOutlet)) {
        components.set(mediaOutlet, []);
      }

      components.get(mediaOutlet).push(
        <SourceCheckerResult
          searchType={selectedSourceType}
          domain={domain}
          authorGroupNames={authorGroupNames}
          isCovered={isCovered}
          isValid={isValid}
          lastCoveredAt={lastCoveredAt}
          mediaOutlet={mediaOutlet}
          showMatchingAuthorGroups
          sourceProviders={sourceProviders}
          storyCount={storyCount}
          hasGroups={hasGroups}
          key={`${domain}_${i}}`}
        />
      );
    }

    return components;
  }, new Map());

  const _components = [];

  const mediaOutletBody = (key, items) => {
    return (
      <div key={key}>
        <Label>{key}</Label>
        <div className={styles.sourceDetails}>{items}</div>
      </div>
    );
  };

  const similarsMediaOutletBody = (sources) => {
    const similarComponentsMap = sources.reduce((map, similarSource, i) => {
      const showResult = filterHandler(filters, similarSource);

      if(showResult) {
        if(!map.has(similarSource.mediaOutlet)) {
          map.set(similarSource.mediaOutlet, []);
        }
        map.get(similarSource.mediaOutlet).push(
          <SourceCheckerResult
            searchType={selectedSourceType}
            domain={similarSource.domain}
            authorGroupNames={similarSource.authorGroupNames}
            isCovered={similarSource.isCovered}
            isValid={similarSource.isValid}
            lastCoveredAt={similarSource.lastCoveredAt}
            mediaOutlet={similarSource.mediaOutlet}
            showMatchingAuthorGroups
            sourceProviders={similarSource.sourceProviders}
            storyCount={similarSource.storyCount}
            hasGroups={hasGroups}
            key={`${similarSource.domain}_${i}}`}
          />
        );
      }

      return map;
    }, new Map());

    const similarComponents = [];
    similarComponentsMap.forEach((items, mediaOutletKey) => {
      similarComponents.push(mediaOutletBody(mediaOutletKey, items));
    });

    return similarComponents;
  };

  resultComponentsMap.forEach((components, key) => {
    _components.push(
      <div className={styles.sourceWrapper} key={`${key}`}>
        {mediaOutletBody(key, components)}
        {similarSources.has(key) && showSourceCheckerSimilars[key]
          ? similarsMediaOutletBody(similarSources.get(key))
          : null
        }
        <div className={styles.showSimilarLink}>
          {showSourceCheckerSimilars[key]
            ? (
              <Link linkType="cancel" onClick={() => {onHideSimilarSources(key);}}>
                Hide media outlets similar to {key} <ChevronUpIcon />
              </Link>
            )
            : (
              <div>
                <Link linkType="cancel" onClick={() => {onShowSimilarSources(key);}}>
                  Show media outlets similar to {key} <DropdownIcon />
                </Link>
                &nbsp;
                {fetchingSimilarFor === key ? <Loading width="15" height="15" /> : null}
              </div>
            )
          }
        </div>
      </div>
    );
  });

  return (
    <div className={styles.listWrapper}>
      {_components}
    </div>
  );
};

SourceCheckerMediaOutletList.propTypes = {
  styles: PropTypes.object,
  selectedSourceType: PropTypes.string,
  results: PropTypes.array,
  filters: PropTypes.object,
  filterHandler: PropTypes.func,
  onShowSimilarSources: PropTypes.func,
  onHideSimilarSources: PropTypes.func,
  similarSources: PropTypes.object,
  showSourceCheckerSimilars: PropTypes.object,
  fetchingSimilarFor: PropTypes.string,
  hasGroups: PropTypes.bool,
};

export default SourceCheckerMediaOutletList;
